export async function getPlatformHeaders(): Promise<Record<string, string>> {
    return {};
}
